import {
  SubscriptionsPage,
  ViewType,
  viewTypes
} from "@/features/subscriptions";
import { requireAdmin } from "@/lib/tanstack-router/requireAdmin";
import { createFileRoute } from "@tanstack/react-router";

const subscriptionTypes = ["inbound", "outbound"] as const;
type SubscriptionType = (typeof subscriptionTypes)[number];
const subscriptionTypeSet = new Set<string>(subscriptionTypes);
const toSubscriptionType = (value: unknown): SubscriptionType | undefined =>
  typeof value === "string" && subscriptionTypeSet.has(value)
    ? (value as SubscriptionType)
    : undefined;

const viewTypeSet = new Set<string>(viewTypes);
const toViewType = (value: unknown): ViewType | undefined =>
  typeof value === "string" && viewTypeSet.has(value)
    ? (value as ViewType)
    : undefined;

type SubscriptionFilter = {
  view?: ViewType;
  subscriptionType?: SubscriptionType;
};

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/"
)({
  component: requireAdmin(Subscriptions),
  validateSearch: (search: Record<string, unknown>): SubscriptionFilter => ({
    view: toViewType(search.view),
    subscriptionType: toSubscriptionType(search.subscriptionType)
  })
});

function Subscriptions() {
  const { view, subscriptionType } = Route.useSearch();
  return (
    <SubscriptionsPage view={view} defaultSubscriptionsTab={subscriptionType} />
  );
}
